import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import type { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ACTION_ERROR_TITLE } from '../../interceptors/http-error.interceptor';
import type {
  CreateEduBudgetCorrection,
  EduBudgetCorrection,
} from '../../models/api/edu-budget-correction.model';
import type { Page } from '../../models/api/page.model';

@Injectable({
  providedIn: 'root',
})
export class EduBudgetCorrectionService {
  private readonly httpClient = inject(HttpClient);
  private readonly eduBudgetCorrectionApi = `${environment.apiUrl}/v1/edu-equ-budget-corrections`;

  getEduBudgetCorrections(pageNo: number): Observable<Page<EduBudgetCorrection>> {
    const context = new HttpContext().set(
      ACTION_ERROR_TITLE,
      'Failed to Get Education Budget Corrections',
    );
    const params = new HttpParams().set('page', pageNo).set('size', 10);
    return this.httpClient.get<Page<EduBudgetCorrection>>(this.eduBudgetCorrectionApi, {
      context,
      params,
    });
  }

  createEduBudgetCorrection(
    eduBudgetCorrection: CreateEduBudgetCorrection,
  ): Observable<EduBudgetCorrection> {
    const context = new HttpContext().set(
      ACTION_ERROR_TITLE,
      'Failed to Create Education Budget Correction',
    );
    return this.httpClient.post<EduBudgetCorrection>(
      this.eduBudgetCorrectionApi,
      eduBudgetCorrection,
      {
        context,
      },
    );
  }

  getEduBudgetCorrection(eduBudgetCorrectionId: number): Observable<EduBudgetCorrection> {
    const context = new HttpContext().set(
      ACTION_ERROR_TITLE,
      'Failed to Get Education Budget Correction',
    );
    return this.httpClient.get<EduBudgetCorrection>(
      `${this.eduBudgetCorrectionApi}/${eduBudgetCorrectionId}`,
      { context },
    );
  }
}
